// ── Dispatch section — Modo Despacho + preview (app entregador + painel)

const DISPATCH_PREVIEW_SRC = '/dispatch-preview.png'

const IconLive = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="3" fill="white"/>
    <circle cx="8" cy="8" r="6" stroke="white" strokeWidth="1.2" opacity="0.3"/>
  </svg>
)

const IconAssign = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 8h9M8 5l3 3-3 3" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 4v8" stroke="white" strokeWidth="1.4" strokeLinecap="round" opacity="0.5"/>
  </svg>
)

const IconWaze = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 2C4.7 2 2 4.7 2 8c0 2.5 1.5 4.7 3.7 5.7l-.2 1.3h5l-.2-1.3C12.5 12.7 14 10.5 14 8c0-3.3-2.7-6-6-6z" stroke="white" strokeWidth="1.2"/>
    <circle cx="6" cy="8" r="1" fill="white"/>
    <circle cx="10" cy="8" r="1" fill="white"/>
    <path d="M6 10.5c.5.5 3.5.5 4 0" stroke="white" strokeWidth="1" strokeLinecap="round"/>
  </svg>
)

const IconWhatsApp = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 1.5C4.4 1.5 1.5 4.4 1.5 8c0 1.2.3 2.3.9 3.3L1.5 14.5l3.3-.9c1 .6 2.1.9 3.2.9 3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5z" stroke="white" strokeWidth="1.2"/>
    <path d="M5.5 6.5c.2.5.8 1.5 1.5 2s1.8 1 2 1l.8-.8c.1-.1.3-.1.4 0l1.3 1c.1.1.1.3 0 .4-.5.5-1.2.8-1.9.7C8 10.7 5.3 8 5.2 6.8c-.1-.7.2-1.4.7-1.9.1-.1.3-.1.4 0l1 1.3c.1.1.1.3 0 .4l-.8.9z" fill="white" opacity="0.7"/>
  </svg>
)

const features = [
  { Icon: IconLive,     text: 'Localização dos entregadores em tempo real' },
  { Icon: IconAssign,   text: 'Atribuição de pedidos por proximidade' },
  { Icon: IconWaze,     text: 'Integração com Waze para navegação' },
  { Icon: IconWhatsApp, text: 'Contato direto via WhatsApp' },
]

export default function Dispatch() {
  return (
    <section
      className="px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24"
      style={{ background: '#0E0E0C' }}
    >
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-8 xl:gap-12 lg:items-start">

          <div className="flex-1 min-w-0 max-w-[520px] lg:max-w-[38%] xl:max-w-[400px] lg:flex-shrink-0">
            <div className="inline-flex items-center gap-2 border border-white/10 rounded-full px-3 py-1.5 text-[11px] font-bold uppercase tracking-[1px] text-white/40 mb-5">
              Modo Despacho
            </div>
            <h2 className="text-[28px] sm:text-[36px] lg:text-[46px] font-black tracking-tight leading-[1.08] text-white mb-4">
              Gerencie seus<br />entregadores em<br />tempo real.
            </h2>
            <p className="text-[15px] lg:text-[16px] text-white/50 leading-[1.75] max-w-[420px] mb-8">
              Veja onde seus entregadores estão, atribua pedidos pelo painel e acompanhe cada entrega do preparo à porta do cliente.
            </p>

            <div className="flex flex-col gap-3.5">
              {features.map(({ Icon, text }) => (
                <div key={text} className="flex items-center gap-3">
                  <div
                    className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ background: 'rgba(255,255,255,0.08)' }}
                  >
                    <Icon />
                  </div>
                  <span className="text-[14px] text-white/70">{text}</span>
                </div>
              ))}
            </div>

            <a
              href="https://dash.waithere.com.br"
              className="inline-flex items-center gap-2 mt-8 no-underline text-[13px] font-semibold text-white/40 hover:text-white/70 transition-colors"
            >
              Ver no painel →
            </a>
          </div>

          <div className="flex-1 min-w-0 w-full flex justify-center lg:justify-end">
            <div className="w-full max-w-[640px] sm:max-w-[720px] mx-auto lg:mx-0 lg:max-w-none rounded-2xl overflow-hidden bg-white shadow-[0_40px_100px_rgba(0,0,0,0.35)] border border-white/[0.08] ring-1 ring-white/5">
              <img
                src={DISPATCH_PREVIEW_SRC}
                alt="App do entregador ao lado do painel do restaurante Waithere — fluxo de despacho em celular e no computador"
                className="w-full h-auto block select-none"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
